import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { DeliveryScenario, Module } from '@app/models/users';
import { INN_PATTERN } from '@components/daData';

import { IFormValues } from '../interfaces';

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IFormValues> =>
  Yup.object().shape({
    module: Yup.mixed<Module>().required(t('required')),
    inn: Yup.string().required(t('required')).matches(INN_PATTERN, t('innFormat')),
    contract_number: Yup.string().trim().required(t('required')),
    contract_date: Yup.string().required(t('required')),
    scenario: Yup.mixed<DeliveryScenario>().required(t('required')),
  });
